import { IFlippData } from './flipp.data';
import { IFlippProps } from './flipp.props.autogenerated';

export interface IFlippViewProps extends IFlippProps<IFlippData> {}

const Flipp = (props: IFlippProps<IFlippData>) => {
    return props.renderView(props);
};

export default Flipp;
